import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-instruction-sinhala',
  templateUrl: '../views/instructions.sinhala.component.html',
  styleUrls: ['../views/staff.component.css','../../../css/instructions.component.css', '../../../css/paper-sets.component.css', '../../setting/setting.component.css']

})
export class InstructionsSinhalaComponent implements OnInit {

  constructor() { 
    
  }

  ngOnInit() {

  }

}



// WEBPACK FOOTER //
// /usr/share/nginx/grade5_live/grade5-frontend-2.0/src/app/core-modules/instructions/components/instructions-sinhala.component.ts